import { adminRoutes } from 'companySettings/routes';
import { customerContacts, vendorContacts } from 'contacts/routes';
import { dashboard } from 'dashboard/routes';
import { elementTemplateDetails, elementTemplateList } from 'elements/routes';
import { externalQuote } from 'external-quote/routes';
import { home, logoHome } from 'home/routes';
import { iframeRoutes } from 'iframe/routes';
import { job, jobs } from 'jobs/routes';
import { messages } from 'messages/routes';
import { customerOrders, orderParts, vendorOrders } from 'orders/routes';
import { partBoms } from 'partBoms/routes';
import { partFinderRoutes } from 'partFinder/routes';
import { parts } from 'parts/routes';
import {
  companyConfigurators,
  companyParts,
  configurators,
  elements,
  manufacturers,
} from 'partsOld/routes';
import { costingProfile, costingProfiles, pricingProfile, pricingProfiles } from 'pricing/routes';
import { companySettings, userProfile } from 'profile/routes';
import { project, projects } from 'projects/routes';
import { customerQuotes, quoteParts, vendorQuotes } from 'quotes/routes';
import { reports } from 'reports/routes';
import {
  supportRequestHome,
  supportRequestJobList,
  supportRequestJobsAdd,
  supportRequestJobsEdit,
  supportRequestList,
} from 'support/routes';
import { systemSettings } from 'system/routes';

import { Route } from './types';

export const routes: Route[] = [
  ...adminRoutes,
  ...partFinderRoutes,
  ...iframeRoutes,
  home,
  logoHome,

  externalQuote,

  parts,
  partBoms,
  manufacturers,
  configurators,
  elements,

  companyParts,
  elementTemplateList,
  elementTemplateDetails,
  companyConfigurators,

  systemSettings,

  projects,
  project,

  customerQuotes,
  vendorQuotes,
  quoteParts,

  customerOrders,
  vendorOrders,
  orderParts,

  messages,

  jobs,
  job,

  customerContacts,
  vendorContacts,

  pricingProfiles,

  userProfile,
  companySettings,
  ...reports,
  ...dashboard,

  supportRequestHome,
  supportRequestList,
  supportRequestJobList,
  supportRequestJobsAdd,
  supportRequestJobsEdit,

  costingProfiles,
  costingProfile,
  pricingProfile,
  pricingProfiles,
];
